import React, { useContext } from 'react';
import styled from 'styled-components';

import { ReactComponent as PayrollProcessIcon } from '@ubeya/shared-web/assets/payroll-process.svg';
import { ReactComponent as PayQueryQuestionMarkIcon } from '@ubeya/shared-web/assets/payroll-query-question-mark.svg';

import { FlexCenter, SmallBodyBold, Tooltip } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { PAYROLL_PROCESS_STATUS } from '@ubeya/shared-web/constants';

export const AlignedFlexDiv = styled(FlexCenter)`
  gap: 5px;
`;

const SmallToolTip = styled.div`
  max-width: 300px;
  text-align: center;
`;

const QuestionMarkIcon = styled(PayQueryQuestionMarkIcon)`
  width: 15px;
`;

const PayrollProcessAggregatorRenderer = ({ rowData: { summarized, subRows } }) => {
  const { t } = useContext(ConfigContext);

  if (summarized) {
    return <></>;
  }

  const totalRows = subRows.length;
  const totalProcessed =
    subRows &&
    subRows.filter(({ payrollProcess }) => payrollProcess?.status === PAYROLL_PROCESS_STATUS.PROCESSED).length;

  const existPayQuery =
    subRows && subRows.some(({ payrollProcess }) => payrollProcess?.status === PAYROLL_PROCESS_STATUS.PAY_QUERY);

  if (totalProcessed === totalRows) {
    return <PayrollProcessIcon />;
  }

  return (
    <AlignedFlexDiv>
      <SmallBodyBold>
        {totalProcessed}/{totalRows}
      </SmallBodyBold>
      {existPayQuery && (
        <Tooltip body={<SmallToolTip>{t('payrollQueryPresentInGroup')}</SmallToolTip>}>
          <QuestionMarkIcon />
        </Tooltip>
      )}
    </AlignedFlexDiv>
  );
};

export default PayrollProcessAggregatorRenderer;
